import ButtonsBarV2 from "./buttons-bar";

export * from "./buttons-bar";

export default ButtonsBarV2;
